import {
  GET_USER_MEAL_PLAN,
  GET_USER_MEAL_PLAN_SUCCESS,
  GET_USER_MEAL_PLAN_ERROR,
  SAVE_USER_MEAL_PLAN,
  SAVE_USER_MEAL_PLAN_SUCCESS,
  SAVE_USER_MEAL_PLAN_ERROR,
  DELETE_USER_MEAL_PLAN,
  DELETE_USER_MEAL_PLAN_SUCCESS,
  DELETE_USER_MEAL_PLAN_ERROR,
} from './constants';

export function getUserMealPlan() {
  return {
    type: GET_USER_MEAL_PLAN,
  };
}

export function getUserMealPlanSuccess(payload) {
  return {
    type: GET_USER_MEAL_PLAN_SUCCESS,
    payload,
  };
}

export function getUserMealPlanError(error) {
  return {
    type: GET_USER_MEAL_PLAN_ERROR,
    error,
  };
}

export function saveUserMealPlan(mealPlan, callback) {
  return {
    type: SAVE_USER_MEAL_PLAN,
    mealPlan,
    callback,
  };
}

export function saveUserMealPlanSuccess(payload) {
  return {
    type: SAVE_USER_MEAL_PLAN_SUCCESS,
    payload,
  };
}

export function saveUserMealPlanError(error) {
  return {
    type: SAVE_USER_MEAL_PLAN_ERROR,
    error,
  };
}

export function deleteUserMealPlan(userMealPlanId) {
  return {
    type: DELETE_USER_MEAL_PLAN,
    userMealPlanId,
  };
}

export function deleteUserMealPlanSuccess(payload) {
  return {
    type: DELETE_USER_MEAL_PLAN_SUCCESS,
    payload,
  };
}

export function deleteUserMealPlanError(error) {
  return {
    type: DELETE_USER_MEAL_PLAN_ERROR,
    error,
  };
}
